import React from 'react';
import SoldOutRecommendationItem from './SoldOutRecommendationItem.jsx';
import {SliderTypes} from '../slider-types.js';
import SliderLandmarkHelper from '@core/scripts/components/tracking/landmarks/slider-landmark-helper.js';

export default function SoldOutRecommendationContent({recoData, className, children, target}) {
    if (!recoData) return null;

    const {multiplePricesText, recommendationProducts} = recoData;

    const onSoldOutRecommendationItemClicked = (event, item) => {
        const landmarkData = recoData?.landmarkData;
        const {itemNumber, productDigistyleId, productImageId} = item;
        SliderLandmarkHelper.createAndSendSlideClickedLandmark(
            SliderTypes.SOLD_OUT,
            productImageId,
            itemNumber,
            productDigistyleId,
            null,
            landmarkData,
        );
    };

    return (
        <div className="sold-out-carousel-slider__container">
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px'}}>
                {recommendationProducts?.map((item, index) => (
                    <div key={item.id || item.itemNumber || index} onClick={(e) => onSoldOutRecommendationItemClicked(e, item)}>
                        <SoldOutRecommendationItem
                            item={item}
                            className={className}
                            multiplePricesText={multiplePricesText}
                            target={target}
                        >
                            {children}
                        </SoldOutRecommendationItem>
                    </div>
                ))}
            </div>
        </div>
    );
}
